// extracted by mini-css-extract-plugin
export var alternate = "video-and-text-module--alternate--8e9e3";
export var contentBlock = "video-and-text-module--contentBlock--a4997";
export var root = "video-and-text-module--root--8b815";
export var video = "video-and-text-module--video--19c57";
export var wrapper = "video-and-text-module--wrapper--8cacb";